import React from 'react';
import { PropTypes } from 'prop-types';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { primaryActionButton } from '../styles/generic';

const AddItemFloatingActionButton = ({ onClick }) => (
  <FloatingActionButton style={primaryActionButton} onClick={onClick}>
    <ContentAdd />
  </FloatingActionButton>
);

AddItemFloatingActionButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default AddItemFloatingActionButton;



// WEBPACK FOOTER //
// ./src/components/AddItemFloatingActionButton.js